<alaris-dialog
		[closeAction]="close.bind(this)"
		[confirmAction]="confirm.bind(this)"
		[loading$]="service.loading$"
		[confirmButtonText]="'gl.delete'"
		size="md"
		class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>{{ 'camara_rules.removingDialogTitle' | translate }}</div>
	</h3>
	<div slot="content">
		<p>{{ 'camara_rules.removingDialog' | translate }} <strong>{{ data.rule.id }}</strong></p>
	</div>
</alaris-dialog>